import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=6fd13998&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fd13998')) {
      api.createRecord('6fd13998', component.options)
    } else {
      api.reload('6fd13998', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=6fd13998&", function () {
      api.rerender('6fd13998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uSlHdp6mEqUh/JS/comp/ImageCarousel.vue"
export default component.exports